import { defineMessages } from 'react-intl';

import { PandoraTypes } from './SourceTypes';

export const messages = defineMessages({
  copyLink: {
    id: 't.copyLink',
    defaultMessage: 'Copy Link',
  },
  copyLinkPrompt: {
    id: 't.copyLinkPrompt',
    defaultMessage: 'Link will be copied to your clipboard',
  },
  linkCopied: {
    id: 't.linkCopied',
    defaultMessage: 'Link copied.',
  },
  byArtist: {
    id: 't.byArtist',
    defaultMessage: 'by {artist}',
  },
  byPodcastCreator: {
    id: 't.byPodcastCreator',
    defaultMessage: '{publisher}',
  },
  byPlaylist: {
    id: 't.byPlaylist',
    defaultMessage: 'Playlist by {artist}',
  },
  postTo: {
    id: 't.postTo',
    defaultMessage: 'Post to',
  },
  facebook: {
    id: 't.facebook',
    defaultMessage: 'Facebook',
  },
  twitter: {
    id: 't.twitter',
    defaultMessage: 'Twitter',
  },
  song: {
    id: 't.song',
    defaultMessage: 'Song',
  },
  album: {
    id: 't.album',
    defaultMessage: 'Album',
  },
  station: {
    id: 't.station',
    defaultMessage: 'Station',
  },
  playlist: {
    id: 't.playlist',
    defaultMessage: 'Playlist',
  },
  episode: {
    id: 't.episode',
    defaultMessage: 'Episode',
  },
  shareFailMessage: {
    id: 't.shareFailMessage',
    defaultMessage: '{shareSourceType} could not be shared. Please try again later.',
  },
  twitterBoilerplate: {
    id: 't.twitterBoilerplate',
    defaultMessage: '🎧 {sourceName} by {artist} on @PandoraMusic\n{sourcePath}',
  },
  twitterBoilerplateNoArtist: {
    id: 't.twitterBoilerplateNoArtist',
    defaultMessage: '🎧 {sourceName} on @PandoraMusic\n{sourcePath}',
  },
  twitterBoilerPlateCreator: {
    id: 't.twitterBoilerPlateCreator',
    defaultMessage: '🎧 {artist} on @PandoraMusic\n{sourcePath}',
  },
  showAlternateSharing: {
    id: 't.showAlternateSharing',
    defaultMessage: 'Toggle options of which station, track, album, or playlist to share',
  },
  closeModal: {
    id: 't.closeModal',
    defaultMessage: 'Close Modal',
  },
  trackLength: {
    id: 't.trackLength',
    defaultMessage: 'Song - {length}',
  },
  trackCount: {
    id: 't.trackCount',
    defaultMessage: '{trackCount} {trackCount, plural, one {song} other {songs}}',
  },
  trackCountAlbum: {
    id: 't.trackCountAlbum',
    defaultMessage: 'Album - {trackCount} {trackCount, plural, one {song} other {songs}}',
  },
  episodeCount: {
    id: 't.episodeCount',
    defaultMessage: '{episodeCount} {episodeCount, plural, one {Episode} other {Episodes}}',
  },
} as const);

export const shareMessages = defineMessages({
  sourceType: {
    id: 't.shareMessages',
    defaultMessage: `Share {sourceType, select,
            ${PandoraTypes.ALBUM} {Album}
            ${PandoraTypes.SONG} {Song}
            ${PandoraTypes.PLAYLIST} {Playlist}
            ${PandoraTypes.STATION} {Station}
            ${PandoraTypes.PODCAST} {Podcast}
            ${PandoraTypes.EPISODE} {Episode}
            ${PandoraTypes.ARTIST} {Artist}
            ${PandoraTypes.CURATOR} {Curator}
            other {Song}
        }`,
  },
} as const);

export const FACEBOOK = 'facebook';
export const TWITTER = 'twitter';
export const COPY = 'copy';
export const TABS = 'tabs';
export const ArtistLabel = 'Artist';
export const CuratorLabel = 'Curator';
export const DefaultMetaTagDescription = 'Listen on Pandora';
